import {
    UPDATE_AUDIO_INFO,
    PLAY_AUDIO
}
    from './types';

export const sendAudioInfo = (audioInfo, audioTracks) => dispatch => {
    console.dir(audioInfo);
    // let newState = {
    //     audioInfo: audioInfo,
    //     audioTracks: audioTracks
    // };

    dispatch({
        type: UPDATE_AUDIO_INFO,
        payload: audioInfo
    });
};

export const playAudioBool = (playAudio, episodeId, loadingAudio, maxDuration) => dispatch => {
    // console.log(progress);
    let newState = {
        playAudio: playAudio,
        // playProgress: progress,
        currentEpisodeId: episodeId,
        loadingAudio: loadingAudio,
        maxDuration: maxDuration
    };

    dispatch({
        type: PLAY_AUDIO,
        payload: newState
    });
};

// export const playAudioProgress = (progress) => dispatch => {
//     // console.log(progress);
//     let newState = {
//         playProgress: progress
//     };

//     dispatch({
//         type: PLAY_AUDIO,
//         payload: newState
//     });
// };